import { IApplicationData } from "../../model/application-data";
import { IAuthenticationData } from "../../model/authentication-data";
import { IAuthenticationResponse } from "../../model/security/response/authentication-response";

const defaultTestApplicationData = {
    // multitenant: 7, //IPMBRASIL
    multitenant: 3851, //DOCGED SISTEMAS
    // multitenant: 3901, //AIRDOC/
    moduleId: 2,
    moduleName: "SCP",
    // baseUrlAuthentication: 'https://api.autenticacao.docgedsistemas.com.br/',
    // baseUrl: "https://api.scp.docgedsistemas.com.br/",
    baseUrlAuthentication: ' http://localhost:5186/',
    baseUrl: "http://localhost:5071/",
    initialPage: "dashboard",
    moduleDescription: "Sistema de Contraçãoes Públicas",
} as IApplicationData;

// const defaultTestApplicationData = {
//     multitenant: 7,
//     moduleId: 1,
//     moduleName:"IPM SDP",
//     baseUrlAuthentication: ' http://localhost:5186/',
//     baseUrl: "http://localhost:5052/",
//     imageLogo: "/img/logo_sdp.png",
//     initialPage: "dashboard",
//     moduleDescription: "Sistema de Diagramação e Publicação",
// } as IApplicationData;


const getApplicationData = (): IApplicationData => {

    var applicationData = {} as IApplicationData;

    var url = window.location.hostname.toLowerCase();

    if (url.includes("ipmbrasil")) {
        applicationData.multitenant = 7
        applicationData.baseUrlAuthentication = "http://account.api.ipmbrasil.org.br/";
        applicationData.baseUrl = "http://scp.api.ipmbrasil.org.br/";
    } else if (url.includes("docgedsistemas")) {
        applicationData.multitenant = 3851
        applicationData.baseUrlAuthentication = "https://api.autenticacao.docgedsistemas.com.br/";
        applicationData.baseUrl = "https://api.scp.docgedsistemas.com.br/";
    } else if (url.includes("airdoc")) {
        applicationData.multitenant = 3901
        applicationData.baseUrlAuthentication = "https://api.autenticacao.airdoc.com.br/";
        applicationData.baseUrl = "https://api.scp.airdoc.com.br/";
    }

    if (url.includes("sdp")) {
        applicationData.moduleId = 1
        applicationData.moduleName = "SDP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Sistema de Diagramação e Publicação";
    } else if (url.includes("scp")) {
        applicationData.moduleId = 2
        applicationData.moduleName = "SCP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Sistema de Contraçãoes Públicas";
    }

    if (url.includes("localhost")) {
        applicationData = defaultTestApplicationData;
    }

    return applicationData;
};

const getAuthenticationData = (): IAuthenticationData | undefined => {
    let value = localStorage.getItem("session_application") as string;
    return JSON.parse(value);
};

const setAuthenticationData = (data: IAuthenticationResponse) => {
    const application = Object.assign({} as IAuthenticationData, data)
    localStorage.setItem("session_application", JSON.stringify(application));
};

const clearAuthenticationData = () => {
    localStorage.removeItem("session_application");
};


const ApplicationAppService = {
    getAuthenticationData, setAuthenticationData, clearAuthenticationData, getApplicationData
};

export default ApplicationAppService;